module.exports = __webpack_public_path__ + "img/general.7c6e0e70.jpg";